import loadable from '@loadable/component';
import Loading from '../../components/Loader';

const HowItWorks = loadable(() => import(/* webpackChunkName: "howItWorks" */ './index'), {
  fallback: Loading
});

export default HowItWorks;
